import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import IconArrowHead from '../IconArrowHead/IconArrowHead';
import css from './Calendar.module.css';

/**
 * Calendar navigation component for week navigation
 */
export const CalendarNavigation = props => {
  const { currentWeek = new Date(), onWeekChange } = props;

  // Get week range for display
  const getWeekRange = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday
    
    const weekStart = new Date(d.setDate(diff));
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);
    
    return { weekStart, weekEnd };
  };

  // Navigate to previous week
  const goToPreviousWeek = () => {
    const newWeek = new Date(currentWeek);
    newWeek.setDate(currentWeek.getDate() - 7);
    onWeekChange(newWeek);
  };

  // Navigate to next week
  const goToNextWeek = () => {
    const newWeek = new Date(currentWeek);
    newWeek.setDate(currentWeek.getDate() + 7);
    onWeekChange(newWeek);
  };

  // Navigate to current week
  const goToCurrentWeek = () => {
    onWeekChange(new Date());
  };

  const { weekStart, weekEnd } = getWeekRange(currentWeek);
  const isCurrentWeek = new Date().getTime() >= weekStart.getTime() && 
                       new Date().getTime() <= weekEnd.getTime();

  return (
    <div className={css.navigation}>
      <button 
        className={css.navButton} 
        onClick={goToPreviousWeek}
        aria-label="Previous week"
      >
        <IconArrowHead className={css.navArrow} />
      </button>
      
      <div className={css.weekDisplay}>
        <div className={css.weekRange}>
          {weekStart.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric' 
          })} - {weekEnd.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric',
            year: 'numeric'
          })}
        </div>
        {isCurrentWeek && (
          <div className={css.currentWeekIndicator}>
            <FormattedMessage id="Calendar.currentWeek" defaultMessage="This week" />
          </div>
        )}
      </div>
      
      <button 
        className={css.navButton} 
        onClick={goToNextWeek}
        aria-label="Next week"
      >
        <IconArrowHead className={`${css.navArrow} ${css.navArrowRight}`} />
      </button>
      
      <button 
        className={css.todayButton} 
        onClick={goToCurrentWeek}
        disabled={isCurrentWeek}
      >
        <FormattedMessage id="Calendar.today" defaultMessage="Today" />
      </button>
    </div>
  );
}; 